import { createI18n  } from "vue-i18n";
import store from "@/store/store";

import ca from '@/i18n/langs/ca'
import es from '@/i18n/langs/es'
import en from '@/i18n/langs/en'
import fr from '@/i18n/langs/fr'
import it from '@/i18n/langs/it'
import de from "@/i18n/langs/de";
import nl from "@/i18n/langs/nl";


const i18n = createI18n({
    legacy: false,
    globalInjection: true,
    locale: store.state.locale!,
    fallbackLocale: 'en',
    messages: {
        ca,
        es,
        en,
        fr,
        it,
        de,
        nl
    }
});


export default i18n;